import { render, staticRenderFns } from "./Binance.vue?vue&type=template&id=24580736&scoped=true"
import script from "./Binance.vue?vue&type=script&lang=js"
export * from "./Binance.vue?vue&type=script&lang=js"
import style0 from "./Binance.vue?vue&type=style&index=0&id=24580736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24580736",
  null
  
)

export default component.exports